<div class="page-header">
  <div class="page-header-title">{{ tournament()?.name || ('field.tournament' | translate) }}</div>
  <div class="page-header-search flex gap-4">
    @if(_.includes(['teams', 'groups', 'standing'], tournamentService.tournamentSection())) {
      <app-search-field></app-search-field>
    }
    @if(tournamentService.tournamentSection() === 'teams') {
      <span>{{ teamService.teamsCount() }} / {{ tournament()?.maxTeams || 0 }}</span>
    }
    @if(authService.hasRole(['admin', 'staff'])) {
      <i class="pi pi-link cursor-pointer" pButtonIcon (click)="iframesPop.toggle($event)"
        [pTooltip]="'button.copy-iframes-codes' | translate" tooltipPosition="left"></i>
    }
  </div>
</div>

<p-menubar [model]="items" [breakpoint]="'1000px'" class="p-menubar-secondary" [ngClass]="{'collapsed': isCollapsed()}">
  <ng-template #item let-item>
    <a [routerLink]="item.route" class="p-menubar-item-link" [ngClass]="{'p-menubar-item-link-active': item.isActive()}">
      <span>{{ item.label }}</span>
    </a>
  </ng-template>
</p-menubar>

<div class="wrapper">
  <router-outlet/>
</div>

<!-- iframes popover -->
<p-popover #iframesPop styleClass="popover-iframes-wrapper">
  <div class="popover-iframes flex gap-4 flex-col">
    <!-- groups iframe -->
    <div class="iframe">
      <div class="popover-subtitle">
        {{ 'iframe.groups' | translate }}
        <p-button variant="outlined" size="small" [label]="'button.copy' | translate" icon="pi pi-copy" 
          (click)="auxiliarService.copyToClipboard(iframeGroups)"/>
      </div>
      <textarea pTextarea [value]="iframeGroups" style="white-space: pre;"></textarea>
    </div>
    <!-- standings iframe -->
    <div class="iframe">
      <div class="popover-subtitle">
        {{ 'iframe.standings' | translate }}
        <p-button variant="outlined" size="small" [label]="'button.copy' | translate" icon="pi pi-copy" 
          (click)="auxiliarService.copyToClipboard(iframeStandings)"/>
      </div>
      <textarea pTextarea [value]="iframeStandings"></textarea>
    </div>
    <!-- rounds iframe -->
    <div class="iframe">
      <div class="popover-subtitle">
        {{ 'iframe.rounds' | translate }}
        <p-button variant="outlined" size="small" [label]="'button.copy' | translate" icon="pi pi-copy" 
          (click)="auxiliarService.copyToClipboard(iframeRounds)"/>
      </div>
      <textarea pTextarea [value]="iframeRounds"></textarea>
    </div>
  </div>
</p-popover>
